import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { isYear } from "../../libs";
// import { useWindowsSize } from "../../libs";

function Footer() {
  const location = useLocation();
  const [visible, setVisible] = useState(false); //untuk visible di login register atau account
  // const size = useWindowsSize();

  useEffect(() => {
    if (location) {
      if (location.pathname.includes("account")) {
        setVisible(false);
      } else {
        setVisible(true);
      }
    }
  }, [location]);

  return (
    <>
      {visible && (
        <div className="footer-s">
          {/* <div className="footer-bg w-full h-32 relative flex px-3 lg:px-10 justify-between items-center">
            <div className="top-0 left-0 w-full h-32 absolute">
              <img
                className="w-full h-32 object-cover"
                src={
                  process.env.REACT_APP_BASE_URL +
                  "/assets/background/bg_footer.svg"
                }
                alt="bg-footer"
              />
            </div>

            <p className="header-title-bold text-lg w-3/5 lg:w-4/5 lg:text-3xl m-0 font-bold text-white ">
              Ingin mendapatkan update dari kami ?
            </p>
            <div className="flex items-center z-10 cursor-pointer">
              <p className="header-title text-xs lg:text-lg m-0 text-white mr-1 lg:mr-3 ">
                Dapatkan notifikasi
              </p>
              <img
                className="w-4 lg:w-auto lg:h-auto"
                src={
                  process.env.REACT_APP_BASE_URL +
                  "/assets/icon/ic_arrow_right.svg"
                }
                alt="icon-arrow"
              />
            </div>
          </div> */}
          <div className="bg-white container mx-auto py-10">
            <div className="grid grid-cols-1 grid-rows-1 lg:grid-cols-3 gap-5 lg:gap-20">
              {/* <div className="flex w-full justify-between"> */}
              <div className="flex justify-center lg:justify-start w-full">
                <div>
                  {/* <p className="header-content m-0 colors-gray text-xs mb-2">
                    Dipersembahkan oleh
                  </p> */}
                  <div className="flex">
                    <Link to="/">
                      <img
                        src={
                          process.env.REACT_APP_BASE_URL +
                          "/assets/logo/labkesmassby.png"
                        }
                        alt="blk-logo"
                        className="cursor-pointer h-24 lg:h-40 w-auto "
                      />
                    </Link>
                  </div>
                  <div className="mt-5 flex items-center">
                    <p className="header-content  m-0 colors-blue text-sm mr-3">
                      Ikuti kami di
                    </p>

                    <a
                      href={process.env.REACT_APP_FACEBOOK}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <img
                        src={
                          process.env.REACT_APP_BASE_URL +
                          "/assets/icon/socialmedia/ic_fb.svg"
                        }
                        alt="icon-fb"
                        className="cursor-pointer h-3 w-auto mr-2"
                      />
                    </a>

                    <a
                      href={process.env.REACT_APP_}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <img
                        src={
                          process.env.REACT_APP_BASE_URL +
                          "/assets/icon/socialmedia/ic_ig.svg"
                        }
                        alt="icon-ig"
                        className="cursor-pointer h-4 w-auto mr-2"
                      />
                    </a>

                    <a
                      href={process.env.REACT_APP_TWITTER}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <img
                        src={
                          process.env.REACT_APP_BASE_URL +
                          "/assets/icon/socialmedia/ic_twitter.svg"
                        }
                        alt="icon-twitter"
                        className="cursor-pointer h-3 w-auto mr-2"
                      />
                    </a>
                  </div>
                </div>
              </div>
              <div className="flex justify-center lg:justify-start w-full">
                <div>
                  <p className="header-title-bold text-lg text-center lg:text-left colors-blue font-bold mt-2 lg:mt-0 lg:m-0 mb-3">
                    Hubungi Kami
                  </p>
                  <div className="grid grid-cols-1 grid-rows-1 lg:grid-cols-2 gap-1 lg:gap-5">
                    <div className="lg:mr-5">
                      <div className="flex items-center">
                        <img
                          src={
                            process.env.REACT_APP_BASE_URL +
                            "/assets/icon/ic_footer_phone.svg"
                          }
                          alt="icon-phone"
                          className="mr-4 h-3 w-3"
                        />
                        <p className="header-content m-0 text-xs colors-gray">
                          031-5020306, 031-5021451
                        </p>
                      </div>
                      {/* <div className="flex items-center my-1">
                        <img
                          src={
                            process.env.REACT_APP_BASE_URL +
                            "/assets/icon/ic_footer_fax.svg"
                          }
                          alt="icon-fax"
                          className="mr-4 h-3 w-3"
                        />
                        <p className="header-content m-0 text-xs colors-gray">
                          031-5020388
                        </p>
                      </div> */}
                      {/* <div className="flex items-center">
                        <img
                          src={
                            process.env.REACT_APP_BASE_URL +
                            "/assets/icon/ic_footer_email.svg"
                          }
                          alt="icon-email"
                          className="mr-4 h-3 w-3"
                        />
                        <p className="header-content m-0 text-xs colors-gray">
                          bblksub@yahoo.co.id
                        </p>
                      </div> */}
                    </div>
                    <div>
                      <div className="flex items-baseline ">
                        <img
                          src={
                            process.env.REACT_APP_BASE_URL +
                            "/assets/icon/ic_footer_location.svg"
                          }
                          alt="icon-location"
                          className="mr-4 h-3 w-3"
                        />
                        <p className="header-content m-0 text-xs colors-gray w-3/4 lg:w-2/3">
                          Jl. Karangmenjangan 18 Surabaya 60286
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="mt-5 lg:mt-0">
                <a
                  href={process.env.REACT_APP_PLAYSTORE}
                  target="_blank"
                  rel="noreferrer"
                >
                  {/* <div className="flex justify-center lg:justify-between">
                    <div></div>
                    <div className="footer-playstore w-3/6 px-4 py-2 lg:px-6 cursor-pointer">
                      <div className="flex items-center">
                        <div className="mr-5">
                          <img
                            src={
                              process.env.REACT_APP_BASE_URL +
                              "/assets/icon/ic_footer_playstore.svg"
                            }
                            alt="icon-playstore"
                          />
                        </div>
                        <div>
                          <p className="header-content text-xs  m-0 text-white">
                            Get it on
                          </p>
                          <p className="header-title text-md font-semibold  m-0 text-white">
                            Google play
                          </p>
                        </div>
                      </div>
                    </div>
                  </div> */}
                </a>
                {/* <div className="flex justify-center lg:justify-between items-center mt-6 lg:mt-3">
                  <Link to="/frequently-ask-question">
                    <p className="header-title-semi lg:ml-20 mr-8 lg:mr-0 colors-gray font-semibold m-0 cursor-pointer">
                      FAQ
                    </p>
                  </Link>
                  <p className="header-title-semi colors-gray font-semibold m-0 cursor-pointer">
                    Term and Condition
                  </p>
                </div> */}
                {/* <div>
                  <p className="header-content m-0 text-xs mt-1 text-center lg:text-right colors-blue mt-6">
                    Copyright © {isYear}. BBLKM Surabaya. All Right Reserved.
                  </p>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default Footer;
